import { ChannelDataOrder, IChannelData, IChannelDataResponse } from "./types";

export function extractErrorMsg(payload) {
  if (payload?.Code && payload?.Message) {
    return payload?.Message;
  }
  if (payload?.CodErro && payload?.MsgErro) {
    return payload?.MsgErro;
  }
  if (payload?.CodigoRetorno && payload?.MessageRetorno) {
    return payload?.MessageRetorno;
  }
  return null;
}

export function hexToRGB(hexColor) {
  return {
    red: parseInt(hexColor.slice(1, 3), 16),
    green: parseInt(hexColor.slice(3, 5), 16),
    blue: parseInt(hexColor.slice(5, 7), 16),
  };
}

export function CatchChannel(res, orderType: ChannelDataOrder) {
  let response = res,
    enabled: IChannelData[] = [],
    disabled: IChannelData[] = [];

  let result: IChannelDataResponse = {
    error: extractErrorMsg(res),
    enabled,
    disabled,
    selected: null,
  };
  if (result.error === null && Array.isArray(response)) {
    response?.forEach((column) => {
      let columnObj: IChannelData = {
        id: column.Id,
        label: column.Desc,
        seq: column.Seq,
        thumbnails: column.Imagem,
        icons: {
          menu: column.UrlLogoPBVetor,
          menuBitmap: column.UrlLogoPBPng,
          table: column.UrlLogoBPVetor,
          tableBitmap: column.UrlLogoBPPng,
        },
        isTotal: column.Rede.IsTotal,
        color:
          "rgb(" + column.Red + "," + column.Green + "," + column.Blue + ")",
      };
      if (column.Selected) {
        enabled.push(columnObj);
      } else {
        disabled.push(columnObj);
      }
    });
    let sortedEnabled = [...enabled];
    sortedEnabled.sort(sortChannelBySeq);
    let sortedDisabled = [...disabled];
    sortedDisabled.sort(sortChannelByLabel);
    result.enabled = sortedEnabled;
    result.disabled = sortedDisabled;
  }
  return result;
}
export function sortChannelByLabel(
  a: { label: string },
  b: { label: string }
): number {
  if (a.label.trim().toUpperCase() < b.label.trim().toUpperCase()) {
    return -1;
  }
  if (a.label.trim().toUpperCase() > b.label.trim().toUpperCase()) {
    return 1;
  }
  return 0;
}
export function sortChannelBySeq(
  a: { seq: number },
  b: { seq: number }
): number {
  return a.seq - b.seq;
}
export function sortChannelByDesc(array: any[]): any[] {
  let sortedEnabled = [...array];
  sortedEnabled.sort((a, b) => a.Desc.localeCompare(b.Desc));
  return sortedEnabled;
}
export function PushDisabledChannels(id, channels, response) {
  let channelsMenuClone = JSON.parse(JSON.stringify(channels));
  let result: IChannelDataResponse = {
    error: null,
    enabled: [...channels.enabled],
    disabled: [...channels.disabled],
    selected: [channels.selected]
  };

  const objFound = channelsMenuClone?.enabled?.find((obj) => {
    return obj.id === id;
  });

  response?.forEach((channel) => {
    if (channel.Id === id) {
      channel.Selected = false;
      channel.Seq = -1;
    }
  });

  if (objFound) result.disabled.push(objFound);
  result.enabled = channelsMenuClone?.enabled?.filter(
    (item) => item.id !== objFound.id
  ); 
  let sorteDisabled = [...result.disabled];
  sorteDisabled.sort(sortChannelByLabel);
  result.disabled = sorteDisabled;
  return result;
}

export function PushEnableChannels(id, channels, response) {
  let channelsMenuClone = JSON.parse(JSON.stringify(channels));
  let result: IChannelDataResponse = {
    error: null,
    enabled: [...channels.enabled],
    disabled: [...channels.disabled],
    selected: [channels.selected],
  };

  const objFound = channelsMenuClone?.disabled?.find((obj) => {
    return obj.id === id;
  });

  response?.forEach((channel) => {
    if (channel.Id === id) {
      channel.Selected = true;
      channel.Seq = result?.enabled?.length;
    }
  });

  if (objFound) result.enabled.push(objFound);
  result.disabled = channelsMenuClone?.disabled?.filter(
    (item) => item.id !== objFound?.id
  );  
  let sorteDisabled = [...result.disabled];
  sorteDisabled.sort(sortChannelByLabel);
  result.disabled = sorteDisabled;
  return result;
}
